/** Tree5 — Support 4 Help (support4help.com) */
export const SITE_NAME = 'Support 4 Help';
export const SITE_DOMAIN = 'support4help.com';
export const SITE_URL = 'https://support4help.com/';

export const COMPANY_NAME = 'Opulence Technologies';
export const COMPANY_ADDRESS = '212 N. 2nd Street, STE 100, Richmond, KY 40475';
